import { LockKeyholeIcon } from "lucide-react";
import { Button } from "../ui/button";
import { Link } from "react-router";
import pages from "@/config/pages";
import { useTranslation } from "react-i18next";

const Footer = () => {
	const { t } = useTranslation();
	return (
		<footer className="bg-moss-green relative text-white py-6 text-center text-sm">
			<div className="flex flex-col md:flex-row justify-center gap-8 mb-2">
				<a
					href="https://www.howdengroup.com/no-en/privacy-data-protection-policy"
					target="_blank"
					rel="noopener noreferrer"
					className="hover:underline hover:text-gray-200 transition-colors duration-200 cursor-pointer"
				>
					{t("footer.privacy-policy")}
				</a>
				<a
					href="https://www.howdengroup.com/no-en/terms-and-conditions"
					target="_blank"
					rel="noopener noreferrer"
					className="hover:underline hover:text-gray-200 transition-colors duration-200 cursor-pointer"
				>
					{t("footer.terms-of-use")}
				</a>
				<a
					href="https://www.howdengroup.com/no-en/cookie-policy"
					target="_blank"
					rel="noopener noreferrer"
					className="hover:underline hover:text-gray-200 transition-colors duration-200 cursor-pointer"
				>
					{t("footer.cookie-policy")}
				</a>
				<a
					href="mailto:person@howdengroup.no"
					className="hover:underline hover:text-gray-200 transition-colors duration-200 cursor-pointer"
				>
					{t("footer.contact")}
				</a>
			</div>
			<p className="mt-2">
				{t("footer.copyrightInfo", { year: new Date().getFullYear() })}
			</p>
			<div className="absolute right-4 top-1/2 hidden md:block -translate-y-1/2">
				<Button size={"icon"} className="bg-moss-green-95" asChild>
					<Link to={pages.Admin}>
						<LockKeyholeIcon />
					</Link>
				</Button>
			</div>
		</footer>
	);
};

export default Footer;
